import React from 'react'


export function documentSizeAware(WrappedComponent) {

    class HOC extends React.Component {

        state = {
            width: 0,
            height: 0
        }



        componentDidMount() {
            this.updateWindowDimensions()
            window.addEventListener('resize', this.updateWindowDimensions)
        }


        componentWillUnmount() {
            window.removeEventListener('resize', this.updateWindowDimensions)
        }


        updateWindowDimensions = () => {
            this.setState({
                width: window.innerWidth,
                height: window.innerHeight
            })
        }


        render() {

            const {width, height} = this.state
            if (!width)
                return null

            return <WrappedComponent {...this.props}
                                     documentWidth={width}
                                     documentHeight={height}
            />
        }
    }

    HOC.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'
    return HOC
}





// WEBPACK FOOTER //
// ./src/hoc/documentSizeAware.js